<template>
  <div class="map-container">



    <transition name="fade" mode="out-in">
      <!-- https://github.com/PNKBizz/vue-yandex-map -->
      <div v-if="!addressLoading" key="map">
        <transition name="fade" mode="out-in">
          <div class="map-container-inner" v-if="!hideLoader">
            <div class="for__loader loader"></div>
          </div>
        </transition>
        <yandex-map
          v-if="!addressLoading"
          :coords="addressCoords"
          :zoom="zoom"
          :controls="['zoomControl']"
          :behaviors="['default']"
          :placemarks="placemarks"
          map-type="map"
          @map-was-initialized="initHandler"
        >
            <ymap-marker
              marker-id="m_address"
              marker-type="placemark"
              :coords="addressCoords"
              :icon="addressIcon"
            ></ymap-marker>
        </yandex-map>


        <div class="map-buttons">
          <map-button
            v-for="item in infrastructureObjects"
            :value="item.id"
            :label="item.text"
            :iconclass="item.iconclass"
            :key="item.key"
            v-model="selectedObject"
          ></map-button>
        </div>
      </div>
    </transition>


    <a href="#more" class="section__link" @click.prevent="addressLoading = !addressLoading" key="btn-start" v-if="!is_touch">
      <span v-if="addressLoading">Посмотреть на карте</span>
      <span v-else>Закрыть карту</span>
    </a>

  </div>
</template>

<script>
import MapButton from './components/MapButton.vue'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
import find from 'lodash.find'
import clone from 'lodash/clone'
import each from 'lodash/each'

export default {
  name: 'dkmap',
  components: {
    MapButton,
    yandexMap,
    ymapMarker
  },

  beforeCreate () {
    if (!_GD.dkmap) {
      _GD.dkmap = {
        zoom: null,
        address: null,
        key: null,
        infrastructureObjects: null,
        bizResults: null,
        bizSpn: null
      };
    }
  },

  created () {
    if (_GD && _GD.dkmap && _GD.dkmap.addressCoords) {
      this.$data.addressCoords = _GD.dkmap.addressCoords;
      if (this.$data.is_touch) {
        this.addressLoading = false
      }
    } else {
      let promise = fetch('https://geocode-maps.yandex.ru/1.x/?format=json&results=1&geocode=' + this.address, {});
          promise
            .then(data => {
              if (data.ok) {
                return data.json()
              }
              throw new Error('Network response was not ok.')
            })
            .then(data => {
              if (data.response.GeoObjectCollection.metaDataProperty.GeocoderResponseMetaData.found != 0) {

                var coords = data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
                if (coords) {
                  var _coords = [
                    parseFloat(coords[1]),
                    parseFloat(coords[0])
                  ]
                  this.$data.addressCoords = _coords;
                }
              }
              if (this.$data.is_touch) {
                this.addressLoading = false
              }
            })
            .catch(error => {
              console.log(error.message);
              // this.addressLoading = false
            });
    }
  },

  data() {
    return {
      mapInstance: null,
      hideLoader: false,
      is_touch: _GD.is_touch,
      zoom: _GD.dkmap.zoom,
      address: _GD.dkmap.address,
      key: _GD.dkmap.key,
      addressLoading: true,
      addressCoords: [55.584466, 37.385471],
      addressIcon: {
        layout: 'default#image',
        imageHref: '//dkrealty.ru/t/dk/i/icons/pin.svg',
        imageSize: [50, 50],
        imageOffset: [-25, -50]
      },
      placemarks: [],
      selectedObject: null,
      cachedInfrastructureObjects: [],
      infrastructureObjects: _GD.dkmap.infrastructureObjects,
      bizResults: _GD.dkmap.bizResults,
      bizSpn: _GD.dkmap.bizSpn,
    }
  },
  methods:{
    initHandler(map){
      this.mapInstance = map;
      var zc = this.mapInstance.controls.get('zoomControl');
          zc.options.set('size', 'small');
          zc.options.set('position', {top: '20px', left: '20px'});
      // disable click on POI
      // this.mapInstance.options.set('yandexMapDisablePoiInteractivity', true);
      this.mapInstance.behaviors.disable('scrollZoom');
      this.hideLoader = true
    },

    fetchBiz(objs, iconPreset){

        let _placemarks = [];

        each(objs, (val) => {

          let coords_string = clone(this.addressCoords).reverse().join(',');
          let url = "https://search-maps.yandex.ru/v1/?results="+this.bizResults+"&lang=ru_RU&apikey=" + this.key + "&text="
                    + val + "&ll="
                    + coords_string + "&spn=" + this.bizSpn
                    ;

          let promise = fetch(url, {});

              promise
                .then(data => {
                  if (data.ok) {
                    return data.json()
                  }
                  throw new Error('Network response was not ok.')
                })
                .then(data => {

                  if (data.features && data.features.length) {

                    each(data.features, (val, key) => {
                      let category = val.properties.CompanyMetaData.Categories[0].name;
                      let name = val.properties.CompanyMetaData.name;
                      // stick category for essence
                      // but remove doubles
                      let rgx = new RegExp(category, 'gi');
                      let hint = (category != name && name.match(rgx) == null) ? category + ' ' + name : name;

                      let p = {
                          coords: val.geometry.coordinates.reverse(),
                          properties: {
                            hintContent: hint,
                          },
                          options: {
                            preset: iconPreset
                            // Custom image for the placemark icon.
                            // iconLayout: 'default#image',
                            // iconImageHref: '//dkrealty.ru/t/dk/i/icons/pin.svg',
                          },
                          // balloonTemplate: '<div class="map-selected-objects-hint">'+(val.properties.CompanyMetaData.shortName||val.properties.CompanyMetaData.name)+'</div>',
                      }
                      _placemarks.push(p);
                    });
                    return _placemarks;
                  }
                })
                .then(data => {
                  this.cachedInfrastructureObjects.push({
                      id: this.selectedObject,
                      placemarks: _placemarks
                    });

                  this.placemarks = _placemarks;
                })
                .catch(error => {
                  console.log(error.message);
                });

        });
    },

    getBiz(objs, iconPreset){
      let cachedObjects = find(this.cachedInfrastructureObjects,['id', this.selectedObject]);
      if (cachedObjects) {
        this.placemarks = cachedObjects.placemarks;
      } else {
        this.fetchBiz(objs, iconPreset);
      }

      // https://tech.yandex.ru/maps/doc/jsapi/2.1/ref/reference/map.GeoObjects-docpage/#removeAll
      // noreload
      // let YMaps = window.ymaps;
      // let map = this.mapInstance;

      // each(this.placemarks, (val, key) => {
      //   var placemark = new YMaps.Placemark(
      //     val.coords, val.properties, val.options
      //   );
      //   map.geoObjects.add(placemark)
      // });


    }
  },
  watch: {
    selectedObject(newValue) {
      this.hideLoader = false
      let selectedObject = find(this.infrastructureObjects,['id', this.selectedObject]);
      let search = (selectedObject.search) ? selectedObject.search : selectedObject.text ;
      this.getBiz(search.split(','), selectedObject.iconPreset);
    }
  },
}
</script>

<style lang="scss">
  @import './../../../../_2017/dk/www/html/css/scss/breakpoints';

  .map-container{
    width: 100%;
    position: relative;

    .amore{
      margin-top: 0;
    }

    &-inner{
      z-index: 1;
      background-color: rgba(255,255,255,0.75);
      position: absolute;
      width: 100%;
      height: 415px;
      @include breakpoint(medium down) {
        height: 305px;
      }
      @include breakpoint(small down) {
        height: 262px;
      }
      .loader{
        left: 50%;
        top: 50%;
        position: absolute;
        margin-left: 0;
        margin-top: 0  !important;
        // transform: translate(50px -50%);
      }
    }

    .ymap-container{
      width: 100%;
      height: 415px;
      @include breakpoint(medium down) {
        height: 305px;
      }
      @include breakpoint(small down) {
        height: 262px;
      }
    }
  }

  .map-buttons {
    margin-top: 30px;

    @include breakpoint(small down) {
      display: none;
    }

    &__btn {
      border-radius: 3px;
      border: 1px solid #c4c4c4;
      padding: 10px 10px 8px;
      line-height: 1.6;
      margin: 0 10px 10px 0;
      &:hover {
        cursor: pointer;
      }
    }
  }


  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/Dkmap.vue